// useAskFacets — the facet inventory the /ask filter picker offers (S4-3, consuming S4-1's
// GET /api/surfaces/query/facets).
//
// LOCAL interface, no contract file — deliberate (house norm: runtime validation is the exception;
// the facets response has no @terum/contracts entry by design, per the build handoff). Sites arrive
// as unlabeled {id, count}: lib/sites.ts SITE_LABEL is the ONE label map (a server label field would
// be the second-definition drift the endpoint's own comment bans).
//
// `enabled` gates the fetch to when the picker actually opens — the inventory is ~28 chunked reads
// server-side, pointless on every composer mount. staleTime 5 min per the surface-hook convention.
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

export interface FacetInventory {
  sites: { id: string; count: number }[];
  people: { name: string; noteCount: number }[];
  projects: { id: string; name: string; count: number }[];
  entryKinds: string[];
  capabilities: {
    sites: 'single' | 'multi' | false;
    since: boolean;
    until: boolean;
    people: boolean;
    projects: boolean;
    entryKinds: boolean;
  };
}

export function useAskFacets(enabled: boolean) {
  const query = useQuery({
    queryKey: ['surfaces', 'query-facets'],
    queryFn: () => apiFetch<FacetInventory>('/api/surfaces/query/facets'),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
  return { ...query, data: query.data ?? undefined };
}
